import { Controller } from "@hotwired/stimulus"
import { isEmpty, showNotification } from "./../helpers"
import { taxNoKindEmpty, taxNoKindPlaceholder } from "../helpers/tax_no"

export default class extends Controller {
  static targets = ["number", "kind", "countryPrefix", "countriesCodes"]

  static values = {
    taxKindMap: Object,
    nipKind: Array,
    translations: Object,
    role: String,
    event: String,
  }

  countriesCodes = {}

  connect() {
    if (this.hasCountriesCodesTarget) this.countriesCodes = JSON.parse(this.countriesCodesTarget.innerHTML)

    if (this.hasCountryPrefixTarget) this.extractTaxNoCountry()

    if (this.hasKindTarget && this.hasNumberTarget) taxNoKindPlaceholder(this.kindTarget, this.numberTarget)
  }

  switchKind() {
    if (this.hasCountryPrefixTarget) {
      this.selectCountrySetOptions(this.getTaxNoOptions(), this.countriesCodes["disabled"])
    }

    taxNoKindEmpty(this.kindTarget, this.numberTarget)
    taxNoKindPlaceholder(this.kindTarget, this.numberTarget)
    this.emitEvent()
  }

  selectCountrySetOptions(options, toDisable = []) {
    this.countryPrefixTarget.replaceChildren(
      ...options.map(item => {
        if (!Array.isArray(item)) {
          const option = document.createElement("option")
          option.disabled = toDisable.includes(item)
          option.textContent = item
          option.value = item
          return option
        }

        const [label, value] = item
        const option = document.createElement("option")
        option.disabled = toDisable.includes(item)
        option.value = toDisable.includes(item) ? "" : value
        option.textContent = label
        return option
      })
    )

    this.toggleCountryElem()
    this.countryPrefixTarget.dispatchEvent(new Event("change"))
  }

  getTaxNoOptions(codesOnly = false) {
    const key = (this.hasKindTarget ? this.taxKindMapValue[this.kindTarget.value] : null) || "empty"

    return codesOnly ? this.codesMap(key) : this.countriesCodes[key]
  }

  codesMap(key) {
    if (this.countriesCodes[`codes_${key}`]) return this.countriesCodes[`codes_${key}`]

    const data = this.countriesCodes[key]
    return data
      .filter(item => Array.isArray(item))
      .map(([_, code]) => code)
  }

  setCountry() {
    this.countryPrefixTarget.querySelectorAll("option[data-original]")
      .forEach((option) => {
        option.text = option.dataset.original
        option.removeAttribute("data-original")
      })

    const selected = this.countryPrefixTarget.selectedOptions[0]
    if (selected && !selected.dataset.original) {
      selected.dataset.original = selected.text
      selected.text = selected.value
    }

    if (this.kindTarget.value === "nip_ue" && isEmpty(this.countryPrefixTarget.value)) {
      showNotification(this.translationsValue["nip_ue_country_reminder"])
    }
  }

  extractTaxNoCountry(e) {
    if (!this.hasNumberTarget) return

    const match = this.numberTarget.value.match(/^[A-Za-z]{2}/)
    if (!match) return null

    const code = match[0].toUpperCase()
    const countryCodes = this.getTaxNoOptions(true)

    const isNipKind = !this.hasKindTarget || this.nipKindValue.includes(this.kindTarget.value)
    const isSeller = this.roleValue === "seller"

    if (isSeller && isNipKind && countryCodes.includes(code)) return null

    // Dla tax_no_kind "other" z wybranym krajem - nie wycinaj prefiksu przy ręcznym wpisaniu,
    // bo numer identyfikacji podatkowej może sam zaczynać się od liter pasujących do kodu kraju.
    // Przy autocomplete (source == "autocomplete") wycinamy zawsze.
    const source = e?.detail?.source
    const isOtherKind = this.hasKindTarget && this.kindTarget.value === "other"
    if (isOtherKind && this.countryPrefixTarget.value && source !== "autocomplete") return null

    // TODO uwzglednic dla korekty  && !GOV_CORRECTION
    if (countryCodes.includes(code)) {
      this.numberTarget.value = this.numberTarget.value.slice(2)
      this.countryPrefixTarget.value = code
      this.countryPrefixTarget.dispatchEvent(new Event("change"))
      this.toggleCountryElem()

      if (isNipKind && countryCodes === this.countriesCodes["codes_pl"]) {
        showNotification(this.translationsValue["nip_country_removed"])
      }
    }
  }

  updateTaxNo() {
    this.emitEvent()
  }

  toggleCountryElem() {
    if (this.countryPrefixTarget.options.length <= 1) {
      this.element.classList.remove("tax-prefix")
    } else {
      this.element.classList.add("tax-prefix")
    }
  }

  emitEvent() {
    this.dispatch(this.eventValue, {
      detail: {
        role: this.roleValue
      }
    })
  }
}
